export const layers = {
  backgrdound: 1,
  header: 2,
  menuShadow: 3,
  menu: 4,
  contact: 999,
}
